var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-bar-chart-container"},[_c('Bar',{ref:"bar-chart",staticClass:"widget-bar-chart",attrs:{"chart-data":_vm.localChartData,"chartOptions":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }